import React, {JSX, useContext } from "react";
import IVendorPending from "../../../models/IVendorPending";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import ReactModal from "react-modal";
import { VendorPendingModal } from "../VendorPendingModal/VendorPendingModal";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    pending: IVendorPending[];
    refreshFn: () => void;
};

export const VendorsPending = (props: Props) => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [modalComponent, setModalComponent] = React.useState<JSX.Element | null>(null);

    const closeModal = () => {
        setModalComponent(null);
        setModalIsOpen(false);

        props.refreshFn();
    };

    const viewPending = (vendorPending: IVendorPending) => {
        const component = <VendorPendingModal vendorPending={vendorPending} closeFn={closeModal} />;

        setModalComponent(component);
        setModalIsOpen(true);
    };

    return (
        <div className={"VendorsPending"}>
            <div>
                <OwTitle title={"pending"} tag={"h5"} />
            </div>
            {props.pending.map((vendorPending) => {
                return (
                    <div key={vendorPending.guid} className={"mb-2"}>
                        <div className={"d-flex align-items-center"}>
                            <div>
                                <OwButton
                                    leftIconClass={"fas fa-magnifying-glass"}
                                    className={"me-2 btn-primary"}
                                    title={"view"}
                                    fn={() => {
                                        viewPending(vendorPending);
                                    }}
                                />
                            </div>
                            <div>
                                {vendorPending.name} - {vendorPending.email} - {vendorPending.company_name} - {vendorPending.company_email}
                            </div>
                        </div>
                    </div>
                );
            })}
            <ReactModal isOpen={modalIsOpen} contentLabel={"Vendor Pending"} className={"modalClass"} overlayClassName={"overlayClass"}>
                {modalComponent}
            </ReactModal>
        </div>
    );
};
